/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type bookmark_book$ref: FragmentReference;
declare export opaque type bookmark_book$fragmentType: bookmark_book$ref;
export type bookmark_book = {|
  +ref: ?string,
  +spaceCounting: ?number,
  +spaceIds: ?$ReadOnlyArray<?string>,
  +$refType: bookmark_book$ref,
|};
export type bookmark_book$data = bookmark_book;
export type bookmark_book$key = {
  +$data?: bookmark_book$data,
  +$fragmentRefs: bookmark_book$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "bookmark_book",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ref",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spaceCounting",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spaceIds",
      "storageKey": null
    }
  ],
  "type": "Bookmark",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '968eb6587c5a4ef8a83fadfc6a5380a6';

module.exports = node;
